import { Box, Paper, Typography } from '@mui/material';
import { DataPipeline, mockPipelineData } from './DataPipeline';

export const DataPipelineDemo = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom>
          Data Pipeline Demo
        </Typography>
        <DataPipeline {...mockPipelineData} />
      </Paper>
    </Box>
  );
};

export default DataPipelineDemo;
